export const OVERLAY_TYPE = {
    CTA: 1,
    POLLING: 2,
    QUESTION_AND_ANSWER: 3,
}

export const SHORT_VIDEO_TRACKING_TYPE = {
    VIEW: 0, // Track after 3s
    SHARE: 1,
    WATCHING: 2, //Skip for now
    CTA_CLICK: 3,
    IMPRESSION: 4, // Video appear in screen (visibility)
    QNA_CLICK: 5,
    POLL_ANSWER: 6,
    CLICK: 7, //For open fullscreen mode
    VIEW_PERCENT: 8,
    LOAD: 9,
    MUTED: 10,
    UN_MUTED: 11,
    PAUSE: 12,
    RESUME: 13,
    ACCESS_FULLSCREEN: 14,
    EXIT_FULLSCREEN: 15,
}

export const PLAYLIST_TYPE = {
    STORY_BLOCK: 1,
    GRID: 2,
    CAROUSEL: 3
}

// Minimum index when call API for the next page
export const MIN_INDEX = 2

export const PAGE_SIZE = 10

export const ORIENTATION_TYPE = {
    PORTRAIT: "PORTRAIT",
    LANDSCAPE: "LANDSCAPE",
}

export const DEVICE_TYPES = {
    IOS_TABLET: 'IOS_TABLET',
    IOS_MOBILE: 'IOS_MOBILE',
    ANDROID_MOBILE: 'ANDROID_MOBILE',
    ANDROID_TABLET: 'ANDROID_TABLET',
    UNKNOWN_TABLET: 'UNKNOWN_TABLET',
    UNKNOWN_MOBILE: 'UNKNOWN_MOBILE',
    DESKTOP: 'DESKTOP',
}

export const VIDEO_STATUS = {
    INACTIVATED: 0,
    ACTIVATED: 1,
    ERROR: 2
}

export const DEFAULT_WATING_TIME = 30 * 1000